import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-sidebar-nav-item',
  standalone: true,
  imports: [RouterLink, LucideAngularModule],
  templateUrl: './sidebar-nav-item.component.html',
  styleUrl: './sidebar-nav-item.component.css',
})
export class SidebarNavItemComponent {
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly route = input.required<string>();
  readonly isActive = input<boolean>(false);
  readonly collapsed = input<boolean>(false);
  readonly badgeCount = input<number>(0);
}
